import type { Collection } from '#shared/types/collection'
import { region } from '#shared/constants/firebase'

/**
 * Composable for collections functionality
 */
export function useCollections() {
    const config = useRuntimeConfig()

    // Build API base URL (works on both server and client)
    const projectId = config.public.FIREBASE_PROJECT_ID
    const isEmulator = config.public.FIREBASE_USE_EMULATOR === 'true'

    const baseURL = isEmulator
        ? `http://localhost:5001/${projectId}/${region}/api`
        : `https://${region}-${projectId}.cloudfunctions.net/api`

    /**
     * Gets a collection by slug
     */
    async function getCollection(slug: string): Promise<Collection> {
        return await $fetch<Collection>(`${baseURL}/collections/${slug}`)
    }

    return {
        getCollection
    }
}
